<template>
  <div>

    <!-- 手机验证码 -->
    <div class="mobile-code">
      <div class="title">手机验证码</div>
      <div class="input-box">
        <input type="text" @keyup.enter="confirm" v-model="mobile" placeholder="请输入手机号码">
      </div>
      <div class="input-box code">
        <input type="text" @keyup.enter="confirm" v-model="vcode" placeholder="请输入验证码">
        <div class="get-code" :class="currentSecond < second?'grey':'blue'" @click="getCode">{{currentSecond < second?`${currentSecond}s`:'获取验证码'}}</div>
      </div>
      <div class="tips">输入手机号验证真伪，验证码一天内有效，同一个验证码查询不会累加扫码次数</div>
      <div class="button" @click="confirm">确认</div>
    </div>

    <K-AlertMsg :AlertMsg="AlertMsg" @AlertBack="AlertBack"></K-AlertMsg>
    <K-ModelLoading v-if="ModelLoading"></K-ModelLoading>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'qr',
  mixins: [mixin],
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      refid: localStorage.getItem("wwmxt_Rootid"),
      template_name: localStorage.getItem("wwm_template_name"),
      second: 60,
      vcode: '',
      mobile: '',
      ModelLoading:false,
      currentSecond: 60
    }
  },
  mounted () {
    this.AdaptiveSizeNew();
  },
  destroyed() {
    this.AdaptiveSize();
  },
  methods: {
    getCode (){
      this.ModelLoading = true;
      if(this.currentSecond === this.second){
        let FormDatas = new FormData();
        FormDatas.append("syid", this.refid);
        FormDatas.append("mobile", this.mobile);
        FormDatas.append("qrcode", this.code);
        axios({
          method: 'post',
          data: FormDatas,
          headers: {
            "Content-Type": "multipart/form-data"
          },
          url: this.GetCxServerUrl() +"wechat-user/get-verification-code",
        }).then((res)=> {
          this.ModelLoading = false;
          var json = res.data;
          if(json.code == 200){
            console.log(json)
            this.countDown();
          }else{
            this.AlertMsg.msg = json.msg;
            this.AlertMsg.state = true;
          }
        }).catch((error)=> {
          this.ModelLoading = false;
          this.AlertMsg.msg = '获取失败';
          this.AlertMsg.state = true;
          console.log(error);
        })
      }
    },
    countDown(){
      const interval = setInterval(()=>{
        this.currentSecond--;
        if(this.currentSecond === 0){
          clearInterval(interval);
          this.currentSecond = this.second;
        }
      },1000)
    },
    confirm(){
      if(!this.mobile){
        this.AlertMsg.msg = '手机号不能为空！';
        this.AlertMsg.state = true;
        return;
      }
      if(!this.vcode){
        this.AlertMsg.msg = '验证码不能为空！';
        this.AlertMsg.state = true;
        return;
      }
      if(this.vcode.length != 4){
        this.AlertMsg.msg = '验证码不正确！';
        this.AlertMsg.state = true;
        return;
      }
      let FormDatas = new FormData();
      FormDatas.append("mobile", this.mobile);
      FormDatas.append("syid", this.refid);
      FormDatas.append("code", this.vcode);
      FormDatas.append("qrcode", this.code);
      this.ModelLoading = true;
      axios({
        method: 'post',
        data: FormDatas,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        url: this.GetCxServerUrl() +"wechat-user/query-qr",
      }).then((res)=> {
        this.ModelLoading = false;
        var json = res.data;
        if(json.code == 200){
          sessionStorage.setItem("wwm_QrData", JSON.stringify(json));
          this.$router.push({path: `/${this.template_name}`});
        }else{
          this.AlertMsg.msg = json.msg;
          this.AlertMsg.state = true;
        }
      }).catch((error)=> {
        this.ModelLoading = false;
        this.AlertMsg.msg = '获取失败';
        this.AlertMsg.state = true;
        console.log(error);
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .mobile-code{
    padding: 30rem;
    margin: 30rem;
    border-radius: 20rem;
    background-color: white;
    .title{
      text-align: center;
      font-size: 28rem;
      margin-bottom: 30rem;
    }
    .tips{
      font-size: 25rem;
      color: #999;
    }
    .input-box{
      padding: 0 20rem;
      margin-bottom: 25rem;
      border-radius: 5rem;
      box-sizing: border-box;
      background-color: #f4f5f9;
      position: relative;
      input{
        width: 100%;
        height: 80rem;
        font-size: 26rem;
        border: none;
        background-color: transparent;
      }
      .get-code{
        position: absolute;
        right: 20rem;
        top: 15rem;
        background-color: white;
        font-size: 23rem;
        height: calc(100% - 30rem);
        display: flex;
        align-items: center;
        width: 160rem;
        justify-content: center;
        text-align: 160rem;
        border-radius: 8rem;
        box-sizing: border-box;
      }
      .blue{
        color: #2c82fd;
        border: 1px solid #2c82fd;
      }
      .grey{
        color: #999;
        border: 1px solid #e0e0e0;
      }
    }
    .code{
      padding-right: 200rem;
    }
    .button{
      color: white;
      text-align: center;
      padding: 20rem 0;
      font-size: 28rem;
      border-radius: 10rem;
      margin-top: 50rem;
      background-color: #2c82fd;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public-view/Mobile.vue